import { gql as o } from "@apollo/client";
const r = o`
  mutation SendForgotPasswordOTP($email: String!) {
    sendForgotPasswordOTP(input: { email: $email })
  }
`;
export {
  r as default
};
//# sourceMappingURL=sendForgotPasswordOTP.js.map
